import { render, staticRenderFns } from "./KoioteEditableInput.vue?vue&type=template&id=30c16a4d&lang=es&"
import script from "./KoioteEditableInput.vue?vue&type=script&lang=js&"
export * from "./KoioteEditableInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports